function Office_Section6() {
  return <></>;
}

export default Office_Section6;
